// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2I6L4","inputWrap":"CustomTip_inputWrap__2doML"};